import api from '@/api/index.js'

const inspection_events = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_INSPECTION_EVENTS_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_INSPECTION_EVENTS: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_INSPECTION_EVENTS_ERROR: (state, error) => {
      state.error = error
    }
  },

  actions: {
    LoadInspectionEvents({commit}, query) {
      commit('SET_INSPECTION_EVENTS_ERROR', null)
      commit('SET_INSPECTION_EVENTS_LOADING', true)
      return api.get(`inspection-events?limit=${query.limit}&offset=0`)
        .then((response) => {
          commit('SET_INSPECTION_EVENTS', response)
        })
        .catch((error) => {
          commit('SET_INSPECTION_EVENTS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_INSPECTION_EVENTS_LOADING', false)
        })
    }
  }
}

export default inspection_events
